/** User-facing names + glyphs for pipeline nodes — the raw graph labels are
 *  internal. Shared by the Pipelines tab diagram and the chat's live
 *  pipeline-progress strip. */

export const NODE_GLYPH: Record<string, string> = {
  input: "⇪", extract: "⊟", agent: "◈", template: "▤", render: "⚙", output: "✓",
  transform: "⇄", mcp_call: "⚡", http: "🌐", crawl: "🕸", nexus_query: "◎",
  file_extract: "⊟", review: "☑",
};
export const glyphOf = (k: string) => NODE_GLYPH[k] || "•";

const STEP: Record<string, string> = {
  input: "Input", extract: "Read", agent: "Prepare", render: "Generate", output: "Done",
  transform: "Shape", mcp_call: "Fetch", http: "Fetch", crawl: "Crawl", nexus_query: "Query",
  file_extract: "Read", review: "Check",
};
export const stepOf = (kind: string, label: string) => STEP[kind] || label;

/** Execution order of a graph's nodes — the same stable topological sweep the
 *  Felix engine runs, so a step list rendered in this order lights up left to
 *  right exactly as the run proceeds. */
export function topoNodes<N extends { id: string }>(
  nodes: N[],
  edges: { source: string; target: string }[],
): N[] {
  const ids = new Set(nodes.map((n) => n.id));
  const preds = new Map<string, string[]>(nodes.map((n) => [n.id, []]));
  for (const e of edges || []) {
    if (preds.has(e.target) && ids.has(e.source)) preds.get(e.target)!.push(e.source);
  }
  const ordered: N[] = [];
  const seen = new Set<string>();
  while (ordered.length < nodes.length) {
    let moved = false;
    for (const n of nodes) {
      if (!seen.has(n.id) && preds.get(n.id)!.every((p) => seen.has(p))) {
        ordered.push(n); seen.add(n.id); moved = true;
      }
    }
    if (!moved) {
      for (const n of nodes) if (!seen.has(n.id)) { ordered.push(n); seen.add(n.id); }
      break;
    }
  }
  return ordered;
}
